// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6cc3fa56","404":"f06778db","498":"1de3630a","787":"d2fe5d62"}[chunkId] + ".chunk.js";
};